import { NavLink, generatePath } from 'react-router-dom';
import { formatBalance } from '@ui/src';
import { CategoryLevelEnum } from '../../../hoc/types';
import ROUTES from '../../../routes';
import { ListItemTypes } from './types';

import cn from './list.module.css';

const getCategoryName = (category: string) => {
  let categoryName;

  switch (category) {
    case CategoryLevelEnum.HIGH:
      categoryName = 'High';
      break;
    case CategoryLevelEnum.MEDIUM:
      categoryName = 'Medium';
      break;
    case CategoryLevelEnum.LOW:
      categoryName = 'Low';
      break;
    default:
      categoryName = category;
      break;
  }

  return categoryName;
};

const ListItem = ({ item, baseCurrency, currencies }: ListItemTypes) => (
  <NavLink
    key={item?.id}
    to={generatePath(ROUTES.TRANSACTIONS_RISK_VOLUME_RISK_EDIT, {
      itemId: item?.id as string,
    })}
    className={cn.volumeRiskTransactionsListItemWrapper}
  >
    <div className={cn.volumeRiskTransactionsListItem}>
      <div className={cn.volumeRiskTransactionsListItemText}>
        {getCategoryName(item?.riskCategory as string)}
      </div>
      <div className={cn.volumeRiskTransactionsListItemText}>{item?.score}</div>
    </div>
    <div className={cn.volumeRiskTransactionsListItem}>
      <div className={cn.volumeRiskTransactionsListItemText}>
        {`${formatBalance(
          item?.individualSingleTransaction?.from || 0,
          currencies?.find(
            (currency) =>
              currency.id === item?.individualSingleTransaction?.currency,
          ) || baseCurrency,
        )}${
          item?.individualSingleTransaction?.to
            ? ` - ${formatBalance(
                item?.individualSingleTransaction?.to,
                currencies?.find(
                  (currency) =>
                    currency.id === item?.individualSingleTransaction?.currency,
                ) || baseCurrency,
              )}`
            : ''
        } ${
          currencies?.find(
            (currency) =>
              currency.id === item?.individualSingleTransaction?.currency,
          )?.name || baseCurrency?.name
        }`}
      </div>
      <div className={cn.volumeRiskTransactionsListItemText}>
        {`${formatBalance(
          item?.individualMultiTransaction?.from || 0,
          currencies?.find(
            (currency) =>
              currency.id === item?.individualMultiTransaction?.currency,
          ) || baseCurrency,
        )}${
          item?.individualMultiTransaction?.to
            ? ` - ${formatBalance(
                item?.individualMultiTransaction?.to,
                currencies?.find(
                  (currency) =>
                    currency.id === item?.individualMultiTransaction?.currency,
                ) || baseCurrency,
              )}`
            : ''
        }  ${
          currencies?.find(
            (currency) =>
              currency.id === item?.individualMultiTransaction?.currency,
          )?.name || baseCurrency?.name
        }`}
      </div>
    </div>
    <div className={cn.volumeRiskTransactionsListItem}>
      <div className={cn.volumeRiskTransactionsListItemText}>
        {`${formatBalance(
          item?.corporateSingleTransacion?.from || 0,
          currencies?.find(
            (currency) =>
              currency.id === item?.corporateSingleTransacion?.currency,
          ) || baseCurrency,
        )}${
          item?.corporateSingleTransacion?.to
            ? ` - ${formatBalance(
                item?.corporateSingleTransacion?.to,
                currencies?.find(
                  (currency) =>
                    currency.id === item?.corporateSingleTransacion?.currency,
                ) || baseCurrency,
              )}`
            : ''
        }  ${
          currencies?.find(
            (currency) =>
              currency.id === item?.corporateSingleTransacion?.currency,
          )?.name || baseCurrency?.name
        }`}
      </div>
      <div className={cn.volumeRiskTransactionsListItemText}>
        {`${formatBalance(
          item?.corporateMultiTransaction?.from || 0,
          currencies?.find(
            (currency) =>
              currency.id === item?.corporateMultiTransaction?.currency,
          ) || baseCurrency,
        )}${
          item?.corporateMultiTransaction?.to
            ? ` - ${formatBalance(
                item?.corporateMultiTransaction?.to,
                currencies?.find(
                  (currency) =>
                    currency.id === item?.corporateMultiTransaction?.currency,
                ) || baseCurrency,
              )}`
            : ''
        } ${
          currencies?.find(
            (currency) =>
              currency.id === item?.corporateMultiTransaction?.currency,
          )?.name || baseCurrency?.name
        }`}
      </div>
    </div>
  </NavLink>
);

export default ListItem;
